var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css()},[_c('OrgHeaderInfo',{attrs:{"heading":_vm.t('module.pat.history.header'),"sub-heading":_vm.t('module.pat.history.subheader')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }